"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLowerCase = exports.deleteNullValues = void 0;
var deleteNullValues = function (obj) {
    Object.keys(obj).forEach(function (prop) {
        if (obj[prop] === null) {
            delete obj[prop];
        }
    });
};
exports.deleteNullValues = deleteNullValues;
var toLowerCase = function (object, exclude) {
    if (exclude === void 0) { exclude = []; }
    Object.keys(object).forEach(function (prop) {
        var value = object[prop];
        if (exclude.indexOf(prop) === -1 && typeof value === 'string') {
            object[prop] = value.toLowerCase();
        }
    });
};
exports.toLowerCase = toLowerCase;
